import { ErrorHandler, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { environment } from '@env/environment';
import { CommonModule } from '@angular/common';
import { BrowserModule, Title } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './modules/core.module';
import { ErrorGlobalHandler } from './errors/global';
import { LanguageInterceptor } from './interceptors/language.interceptor';
import { SharedModule } from './modules/shared.module';
import TVPlayerComponent from '@components/pages/tv/player.component';
import { TokenInterceptor } from './interceptors/token.interceptor';
import {
  SocialLoginModule,
  SocialAuthServiceConfig,
  GoogleLoginProvider,
  FacebookLoginProvider
} from 'angularx-social-login';
import { UnauthorizedInterceptor } from './interceptors/unauthorized.interceptor';

const googleLoginOptions = {
  scope: 'profile email',
  plugin_name: 'sample_login'
};

export function tokenGetter() {
  // console.log('__tokenGetter', localStorage.getItem('jwt_token'));
  return localStorage.getItem('jwt_token');
}

export function jwtOptionsFactory(options) {
  let allowedDomains = options.allowedDomains || [];

  function addAllowedDomains(domain) {
    allowedDomains = [...allowedDomains, domain];
  }

  return {
    addAllowedDomains,
    options: () => ({
      ...options,
      allowedDomains: allowedDomains,
    }),
  };
}

export const jwtOptions = jwtOptionsFactory({
  tokenGetter,
  skipWhenExpired: true,
  headerName: 'Authorization',
  allowedDomains: [
    'api-local.sportsinformations.com',
    'api.sportsinformations.com',
  ],
  disallowedRoutes: []
});

@NgModule({
  declarations: [AppComponent, TVPlayerComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    LazyLoadImageModule,
    SharedModule,
    AppRoutingModule,
    SocialLoginModule,
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptions.options
      }
    })
  ],

  /**
   * ? HTTP_INTERCEPTORS is using onion model
   * * Request A
   * * Request B
   * * Request C
   *  ...
   * * Respond C
   * * Respond B
   * * Respond A
   **/
  providers: [
    Title,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: ErrorGlobalHandler
    },

    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              environment.google_key,
              googleLoginOptions
            )
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(
              environment.facebook_key,
            )
          }
        ]
      } as SocialAuthServiceConfig
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
